// extracted by mini-css-extract-plugin
module.exports = {"childrenMenuList":"HeaderDesktopMenuListSubMenu_childrenMenuList__WS0Yi"};